import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "table-responsive my-2 font-12 border" }
const _hoisted_5 = { class: "table table-borderless mb-0" }
const _hoisted_6 = { class: "table-primary nowrap-text" }
const _hoisted_7 = { scope: "col" }
const _hoisted_8 = { scope: "col" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-nowrap" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { colspan: "5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.getWorkflowList)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("table", _hoisted_5, [
          _createVNode("thead", _hoisted_6, [
            _createVNode("tr", null, [
              _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('estimation_no')), 1),
              _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('action')), 1)
            ])
          ]),
          (_ctx.state.data.workflowLists.length > 0)
            ? (_openBlock(), _createBlock("tbody", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.workflowLists, (estimation, estimationIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: estimationIndex }, [
                    _createVNode("td", null, [
                      _createVNode("p", null, [
                        _createTextVNode("# " + _toDisplayString(estimationIndex + 1) + " " + _toDisplayString(_ctx.$t('workflow_based_on')) + " ", 1),
                        _createVNode("b", null, _toDisplayString(estimation.estimation ?
                                        estimation.estimation.title:''), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('contract')) + ".", 1)
                      ])
                    ]),
                    _createVNode("td", _hoisted_10, [
                      (_ctx.hasRole(['todo_payer', 'todo_member', 'co-owner', 'owner']) && estimation.status === 2)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (_ctx.redirectToPhasesDashboard(estimation.uuid)),
                            class: "btn btn-sm default-btn mr-1 outline"
                          }, [
                            _hoisted_11,
                            _createTextVNode(" " + _toDisplayString(!_ctx.hasRole(['owner']) ?
                                            _ctx.$t('go_to_workflow'):_ctx.$t('go_to_workflow')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_12, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_13, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.heading
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ]))
        ])
      ])
    ])
  ]))
}